<template>
  <el-select v-model="selectValue" multiple filterable placeholder="请选择" @change="change">
    <el-option label="请选择" value=""></el-option>
    <el-option v-for="item in options" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID"></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'FormHospitalMultipleSelect',
  data () {
    return {
      options: [],
      selectValue: this.value
    }
  },
  props: {
    value: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  methods: {
    change: function () {
      this.$emit('input', this.selectValue)
    }
  },
  watch: {
    value (newVal) {
      this.selectValue = newVal
    }
  },
  mounted: function () {
    var that = this
    var args = {
      dictid: 1,
      token: sessionStorage.getItem('token'),
      currentPage: 1,
      pageSize: 99999
    }
    this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/dictitem/list', args, function (data) {
      that.options = data.Data
    }, null, null, null)
  }
}
</script>

<style>
</style>
